import React from "react";
import PropTypes from "prop-types";
import OrganizationForm from "./OrganizationForm";
import { useMutation, useQuery } from "react-query";
import { matchPath } from "react-router-dom";
import {
  loadOrganization,
  updateOrganization,
} from "../../../queries/organization";
import { createErrors } from "../../../queries/helpers";
import { useErrorHandler } from "react-error-boundary";
import { addAdminEmails, addCountry } from "../../helpers";

const EditOrganizationPage = ({ history, toast }) => {
  const handleError = useErrorHandler();
  const organizationId = matchPath(location.pathname, {
    path: "/organizations/:id/edit",
    exact: true,
  })?.params.id;

  const editOrg = useMutation(async (formData) => {
    await updateOrganization(formData, organizationId);
  });

  const {
    isLoading,
    isError,
    data: organization,
  } = useQuery(
    ["organization", organizationId],
    async () =>
      await loadOrganization(organizationId)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          handleError(error);
        }),
    { enabled: !!organizationId }
  );

  const onSubmit = async (values) => {
    let new_values = { ...values };
    new_values = addCountry(new_values);
    new_values = addAdminEmails(new_values);
    return await editOrg
      .mutateAsync(new_values)
      .then(() => {
        toast.success([
          {
            title: "Organization has been updated",
            body: new_values.legalName,
          },
        ]);
        history.push("/");
      })
      .catch((error) => {
        toast.error([
          {
            title: "Failed to update organization",
            body: `${error.response.data.errors
              .map((error) => error.detail)
              .join(", ")}`,
          },
        ]);
        return createErrors(
          error,
          "Failed to create organization",
          handleError
        );
      });
  };

  return (
    <div className="container mw-520">
      {organization && !isLoading && !isError && (
        <>
          <h3 className="mb-4">
            {organizationId ? `Edit organization` : "New organization"}
          </h3>
          <OrganizationForm onSubmit={onSubmit} organization={organization} />
        </>
      )}
    </div>
  );
};

EditOrganizationPage.propTypes = {
  history: PropTypes.object.isRequired,
  toast: PropTypes.func.isRequired,
};

export default EditOrganizationPage;
